import { auditReports } from '@mi-front/api-clients';
import { useRouter } from '@mi-front/core';
import { useToast } from '@app/core/notifications';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { useWizardWithData } from '../../../../../../../../../core/hooks/WizardWithData';
import { aodRoutes } from '../../../../../routing/routes';
import { useAodFactory } from '../../../custom/AodFactory';
import { AodRuleWizardValues } from '../../../types';

export function AodRuleCreator() {
  const { formatMessage } = useIntl();
  const { notifySuccess, notifyError } = useToast();
  const { data, previousStep } = useWizardWithData<AodRuleWizardValues<any, any, any>>();
  const { history } = useRouter();
  const createRuleMutation = auditReports.useCreateOneBaseAodRulesControllerAodRule();
  const { valuesToApi: convertToApi } = useAodFactory(data?.basic.reportType);

  const handleCreateRule = async () => {
    try {
      await createRuleMutation.mutateAsync({
        data: convertToApi(data),
      });

      notifySuccess(
        formatMessage({
          id: 'audit.aod.rules.notifications.created',
          defaultMessage: 'Regla AOD creada',
        }),
      );

      history.push(aodRoutes.rules.gen());
    } catch (error) {
      notifyError(
        formatMessage({
          id: 'audit.aod.rules.notifications.createError',
          defaultMessage: 'Error al crear la regla AOD.',
        }),
      );
      console.error('Error creating AOD Rule:', error);
    }
  };

  return (
    <Box mt={3}>
      <Box>
        <Button
          onClick={handleCreateRule}
          loading={createRuleMutation.isPending}
          variant="outlined"
          color="primary"
          startIcon={<AddIcon />}
          size="large"
        >
          {formatMessage({
            id: 'audit.aod.rules.review.createBtn',
            defaultMessage: 'Crear regla',
          })}
        </Button>
      </Box>
      <Box mt={2}>
        <Button
          color="warning"
          onClick={previousStep}
          variant="outlined"
          sx={{ mr: 1 }}
          disabled={createRuleMutation.isPending}
        >
          {formatMessage({
            id: 'common.actions.back',
            defaultMessage: 'Atrás',
          })}
        </Button>
      </Box>
    </Box>
  );
}
